var App = App || {};

App.PageHome = (function() {
  "use strinct";

  var initialize = function() {
    _initHeroSlides();
  };

  var _initHeroSlides = function() {
    $('.slick-home-hero-slides').slick({
      arrows: false,
      autoplay: true,
      dots: true,
      fade: true,
      infinite: true,
      speed: 500
    });
  };

  return {
    initialize: initialize
  }
})();